import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { OrdersReportList } from './OrdersReportList/OrdersReportList';

export const ordersReportResource: ResourceProps = {
  name: Resources.OrdersReport,
  create: <></>,
  edit: <></>,
  list: OrdersReportList,
  show: <></>,
};
